// extracted by mini-css-extract-plugin
export default {"root":"EvaluateHeader_root__VTmbD","title":"EvaluateHeader_title__ZQQ2x","back":"EvaluateHeader_back__BDw6u"};